//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImagePicker from '@/components/innovation/ImagePicker.vue'
import { resolveMediaUrl } from '@/utils/mediaUrl'
export default {
  components: { ImagePicker },
  data () {
    return {
      myList: [],
      sysList: [],
      draftUrl: '',
      saving: false,
      cat: 'all',
      cats: [
        { k: 'all', n: '全部' },
        { k: 'home', n: '家居' },
        { k: 'school', n: '校园' },
        { k: 'food', n: '美食' },
        { k: 'travel', n: '旅行' }
      ],
      previewShow: false,
      previewImages: []
    }
  },
  created () {
    this.loadMine()
    this.loadSystem('all')
  },
  methods: {
    media (u) { return resolveMediaUrl(u) },
    loadMine () {
      this.$ajax.get(this.$api.mpImageMyList).then(r => { this.myList = r || [] }).catch(() => {})
    },
    loadSystem (c) {
      this.cat = c
      const q = c && c !== 'all' ? ('?category=' + c) : ''
      this.$ajax.get(this.$api.mpImageSystem + q).then(r => { this.sysList = r || [] }).catch(() => {})
    },
    onUploaded (url) {
      if (!url || this.saving) return
      this.persist(url, '我的图片')
    },
    saveFromSystem (img) {
      const url = img.imageUrl || img.image_url
      if (!url) return
      this.persist(url, img.imageName || '系统素材', 'system')
    },
    persist (url, name, source) {
      this.saving = true
      this.$ajax.post(this.$api.mpImageSave, {
        image_url: url,
        image_name: name,
        image_type: 'scene',
        source: source || 'upload'
      }).then(() => {
        this.draftUrl = ''
        this.$toast && this.$toast('已保存到图库')
        this.loadMine()
      }).catch(e => {
        this.$toast && this.$toast(e.message || '保存失败')
      }).finally(() => { this.saving = false })
    },
    toggleFav (img) {
      this.$ajax.post(this.$api.mpImageFavorite, { id: img.id }).then(() => {
        this.loadMine()
      }).catch(e => { this.$toast && this.$toast(e.message || '操作失败') })
    },
    preview (img) {
      const url = resolveMediaUrl(img.imageUrl || img.thumbnailUrl || img.image_url)
      if (!url) return
      this.previewImages = [url]
      this.previewShow = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/memory-palace/gallery.vue